import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogCutomizadoComponent } from '../components/genericos/message-dialog-cutomizado/message-dialog-cutomizado.component';
import { IErrorMessage } from '../interfaces/ierror-message';
import { JwtService } from '../jwt.service';
import { PedidoManager } from 'src/app/managers/pedido-manager';
import { extrairCorpoTexto, extrairMensagemErroApi } from 'src/app/utils/utils/extrair-mensagem-erro-api';

@Injectable({
  providedIn: 'root'
})

export class HttpErrorMessageService {

  iErrorMessage: IErrorMessage;
  isExecutou = false;
  constructor(
    private dialog: MatDialog,
    private jwtService: JwtService,
    private pedidoManager: PedidoManager
  ){}

  /**
   * Retorna a mensagem de negócio devolvida pela API, ou null quando o corpo não for
   * uma mensagem exibível ao usuário.
   *
   * Lógica em extrairMensagemErroApi() (src/app/utils/utils/extrair-mensagem-erro-api.ts),
   * reutilizada por SnackbarManager.openSnackBarErro() sem depender da árvore de injeção
   * deste serviço (evita ciclo: PedidoManager injeta SnackbarManager, e este serviço injeta
   * PedidoManager).
   */
  getMensagemApi(error: HttpErrorResponse): string | null {
    return extrairMensagemErroApi(error);
  }

  /**
   * Corpo da resposta como texto, já com o JSON string literal desempacotado, ou null quando
   * o corpo não é string.
   *
   * É o valor contra o qual TODA comparação de conteúdo deve ser feita — inclusive as
   * comparações literais de getErrorMessage() e openErrorMessageDialog(). Os endpoints que
   * declaram `responseType: 'text'` entregam o corpo com as aspas do Gson, então comparar o
   * corpo cru faria os tratamentos especiais (redirect de sessão, efeito colateral do pedido
   * indisponível) falharem justamente nesses endpoints.
   */
  private getCorpoTexto(error: HttpErrorResponse): string | null {
    return extrairCorpoTexto(error);
  }

  getErrorMessage(error: HttpErrorResponse): IErrorMessage {

    /*
     * A mensagem da API é repassada apenas nos status 400 e 403 — os únicos em que o corpo
     * é comprovadamente produzido por código nosso: o catch dos controllers e o abortWith do
     * CORSInterceptador, ambos serializando com Gson. Nos demais status o corpo vem do
     * container ou do proxy (página HTML de erro), não é mensagem de negócio, e por isso os
     * textos de infraestrutura são mantidos.
     */
    const corpo = this.getCorpoTexto(error);
    const mensagemApi = this.getMensagemApi(error);

    switch (error.status) {
      case 0:
        return this.iErrorMessage = { message: 'Não foi possível conectar ao servidor. Você será redirecionado para o login. Algumas informações podem ter sido perdidas!',
                                 redirect: true }
      case 400:
        if(corpo === "O pedido não está mais disponível!"){
          this.pedidoManager.pedidoIndisponivel();
          return this.iErrorMessage = { message: "Pedido já salvo no servidor, por favor verifique seus pedidos." }
        }
        return this.iErrorMessage = { message: mensagemApi ?? 'Requisição inválida. Verifique os parâmetros enviados.' }
      case 401:
        return this.iErrorMessage = { message: 'Usuário não logado!',
                                      redirect: true }
      case 403:
        if(corpo === "Usuario não logado!"){
          return this.iErrorMessage = { message: 'Usuário não logado!', redirect: true }
        }else{
          return this.iErrorMessage = { message: mensagemApi ?? 'Acesso negado. Você não tem permissão para acessar essa página.' }
        }
      case 404:
        return this.iErrorMessage = { message: 'Página não encontrada.'}
      case 408:
        return this.iErrorMessage = { message: 'Tempo limite da requisição excedido. Verifique sua conexão.' }
      case 429:
        return this.iErrorMessage = { message: 'Muitas requisições. Aguarde um momento e tente novamente.' }
      case 451:
        return this.iErrorMessage = { message: 'Acesso não disponível por motivos legais.' }
      default:
        return this.iErrorMessage = { message: 'Erro desconhecido. Você será redirecionado para o login. Algumas informações podem ter sido perdidas!',
                                      redirect: true }
    }
  }
 
  openErrorMessageDialog(error: HttpErrorResponse) {
    if (!this.isExecutou) {
      this.isExecutou = true;
      /*
       * Restrito a 400/403 — únicos status em que o endpoint de login/autenticação
       * responde. Sem essa restrição, um 500/504 cujo corpo reproduzisse este texto
       * (ex.: eco de payload) escaparia do redirect/logout que esses status exigem.
       */
      if((error.status === 400 || error.status === 403) && this.getCorpoTexto(error) === 'Erro ao Autenticar, verifique seu usuário/senha'){
        this.iErrorMessage = {message:'Erro ao Autenticar, verifique seu usuário/senha'}
      } else{
        this.iErrorMessage = this.getErrorMessage(error); 
      }
      const message = this.iErrorMessage.message;
      const redirect = this.iErrorMessage.redirect;
      const dialogRef = this.dialog.open(MessageDialogCutomizadoComponent, {
        width: '300px',
        disableClose: true,
        data: { message: message }
      });

      dialogRef.afterClosed().subscribe(() => {
        if(redirect)
          this.jwtService.logout();
        this.isExecutou = false;
      });
    }
  }  

}